import { c as _c } from "react/compiler-runtime";
import { LayoutCenter } from 'design-system/server';
import Image, { StaticImageData } from 'next/image';
import { useTranslations } from 'next-intl';
import styles from './ErrorPageLayout.module.css';
import betterplaceLogo from '@/assets/betterplaceLogo.svg';
import Link from '@/components/Link';
import SimpleFooter from '@/components/SimpleFooter';
const ErrorPageLayout = t0 => {
  const $ = _c(10);
  const {
    children
  } = t0;
  const t = useTranslations("nextjs.core");
  let t1;
  if ($[0] !== t) {
    t1 = t("betterplace_logo_alt_text");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <header className={styles.container}><LayoutCenter><Link href={process.env.NEXT_PUBLIC_BETTERPLACE_URL}><Image src={betterplaceLogo as StaticImageData} className={styles.logo} alt={t1} /></Link></LayoutCenter></header>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children) {
    t3 = <LayoutCenter as="main" className={styles.main}>{children}</LayoutCenter>;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SimpleFooter />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3) {
    t5 = <>{t2}{t3}{t4}</>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default ErrorPageLayout;